import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { UserState } from "@store/user/user.state";

export const notFoundGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  const isLoggedIn = store.selectSnapshot(UserState.isLoggedIn);

  if (isLoggedIn) {
    return true;
  }

  return router.createUrlTree(["/login"]);
};
